<template>
    <div>
        <div class="tree-container">
            <tree-node
                v-for="(node, index) in viewData"
                :treeNode="node"
                :api="api"
                :hasCheckbox="hasCheckbox"
                :hasIcon="hasIcon"
                :hasControls="hasControls"
                :hasSingleSelect="hasSingleSelect"
                :hasCascadeSelect="hasCascadeSelect"
                :controls="controls"
                :control-style="controlStyle"
                :key="index"
            ></tree-node>
        </div>
    </div>
</template>

<script>
import TreeNodeClass from './TreeNode.js';
import TreeNode from './TreeNode.vue';

export default {
    name: 'Tree',
    components: {
        TreeNode
    },
    props: {
        dataList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        /* 选中单个 */
        onSelect: {
            type: Function,
            default: treeNode => {}
        },
        /* 打开收起 */
        onToggle: {
            type: Function,
            default: (treeNode, bool) => {}
        },
        /* 是否展示checkbox */
        hasCheckbox: {
            type: Function,
            default: node => {
                return true;
            }
        },
        /* 是否带有icon */
        hasIcon: {
            type: Function,
            default: node => {
                return false;
            }
        },
        /* 是否展示控制按钮 */
        hasControls: {
            type: Function,
            default: node => {
                return true;
            }
        },
        /* 是否能单选这个节点 */
        hasSingleSelect: {
            type: Function,
            default: node => {
                return false;
            }
        },
        /* 是否关联选中层级上节点 */
        hasCascadeSelect: {
            type: Boolean,
            default: false
        },
        /* 每个节点的控制按钮
                [{text, handler(node, api)}, ...]
            */
        controls: {
            type: Array,
            default: []
        },

        controlStyle: {
            type: Object,
            default: () => {
                return {
                    type: 'primary',
                    size: 'small'
                };
            }
        }
    },
    data() {
        return {
            api: this,

            rootNode: null,
            currentNode: null,
            treeNodeMap: {}, // 类别id对应的数据

            treeNodeMapViewData: [], // 从typeMap生成的完整视图
            viewData: null // 可以外部传入的视图
        };
    },
    mounted() {
        this.init();
    },
    watch: {
        dataList: function(value) {
            this.init();
            return value;
        }
    },
    methods: {
        init() {
            this.formatData(this.dataList);
            this.viewData = this.treeNodeMapViewData;
        },
        reset() {
            this.travel(n => {
                if (n.id) {
                    n.node.open = false;
                    n.node.show = true;
                    n.node.match = false;
                    n.node.checked = 0;
                }
            });
        },
        /*
                输出格式化数组
            */
        getData() {
            return this.rootNode.getAllChildren().map(n => n.format());
        },
        /*
                过滤
            */
        travel(func) {
            return this.rootNode.travel(func);
        },
        filter(func) {
            return this.rootNode.filter(func);
        },
        /*
                设置展示的树列表，过滤备用
            */
        checkViewData(list) {
            let tempRoot = new TreeNodeClass({ id: 0, parentId: -1 });
            tempRoot.node.open = true;
            tempRoot.children = list;
            this.viewData = list ? [tempRoot] : this.treeNodeMapViewData;
        },
        /*

            */
        selectNode(node) {
            if (node.node.selected) {
                this.currentNode && (this.currentNode.node.selected = false);
                this.currentNode = node;
            }
            this.onSelect(node);
        },
        /*
                获取节点
            */
        getNode(id) {
            return this.treeNodeMap[id];
        },
        /*
                设置节点，添加or修改
            */
        setNode(data) {
            if (data.parentId >= 0) {
                if (!this.getNode(data.parentId)) {
                    this.addNode({ id: data.parentId });
                }
            }
            if (this.getNode(data.id)) {
                this.modifyNode(data);
            } else {
                this.addNode(data);
            }
            return this.getNode(data.id);
        },
        removeNode(node) {
            if (typeof node === 'number') {
                node = this.getNode(node);
            }
            if (!node) {
                return;
            }
            delete this.treeNodeMap[node.id];
            node.remove();
        },
        // ========================================================================================================
        /*
                格式化输入数据
                创建根节点
                将输入数据变成想要的数据
            */
        formatData(data) {
            this.treeNodeMap = {};
            this.treeNodeMapViewData = [];

            let list = Array.isArray(data) ? data : [];
            this.rootNode = this.addNode({ id: 0, parentId: -1 });
            this.rootNode.node.open = true;
            this.treeNodeMapViewData.push(this.rootNode);
            list.forEach(item => {
                this.setNode(item);
            });
        },
        addNode(data) {
            let node = new TreeNodeClass(data);
            this.getNode(data.parentId) && this.getNode(data.parentId).addChild(node);
            this.treeNodeMap[data.id] = node;
            return node;
        },
        /*
                修改节点
            */
        modifyNode(data) {
            let node = this.getNode(data.id);
            data.parent = this.getNode(data.parentId);
            node.modify(data);
        },

        // 移动节点
        moveNode(data, type) {
            let node = this.getNode(data.id);
            let index = node.parent.children.indexOf(node);

            if (type === 'up') {
                node.parent.children.splice(index, 1);
                node.parent.children.splice(index - 1, 0, node);
            } else if (type === 'down') {
                node.parent.children.splice(index, 1);
                node.parent.children.splice(index + 1, 0, node);
            } else if (type === 'top') {
                node.parent.children.splice(index, 1);
                node.parent.children.unshift(node); // 插入列表头部
            } else if (type === 'bottom') {
                node.parent.children.splice(index, 1);
                node.parent.children.push(node); // 插入列表尾部
            }

            // 重塑sequence
            node.parent.children.forEach((node, index) => {
                node.sequence = index + 1;
            });

            node.parent.checkInfo();
        }
    }
};
</script>

<style lang="scss" scoped>
.tree-container {
    user-select: none;
}
</style>
